import { render, staticRenderFns } from "./DamageLossesEdit.vue?vue&type=template&id=6dfd2ef5"
import script from "../../controllers/damage-losses/damage-losses-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/damage-losses/damage-losses-edit.js?vue&type=script&lang=js&external"
import style0 from "./DamageLossesEdit.vue?vue&type=style&index=0&id=6dfd2ef5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports